import {FC, useState, useEffect, createContext, useContext, Dispatch, SetStateAction, useRef} from 'react'
import {LayoutSplashScreen} from '../../../../_metronic/layout/core'
import {AuthModel, UserModel} from './_models'
import * as authHelper from './AuthHelpers'
import {getUserByToken} from './_requests'
import {WithChildren} from '../../../../_metronic/helpers'
import { SSO } from '../../../../api'
import {v4 as uuidv4} from 'uuid'
import { createNewHeaders, executePost } from '../../../../configs/Kubuku'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const MySwal = withReactContent(Swal)

type AuthContextProps = {
  auth: AuthModel | undefined
  saveAuth: (auth: AuthModel | undefined) => void
  currentUser: UserModel | undefined
  setCurrentUser: Dispatch<SetStateAction<UserModel | undefined>>
  logout: () => void
}

const initAuthContextPropsState = {
  auth: authHelper.getAuth(),
  saveAuth: () => {},
  currentUser: undefined,
  setCurrentUser: () => {},
  logout: () => {

  },
}

const AuthContext = createContext<AuthContextProps>(initAuthContextPropsState)

const useAuth = () => {
  return useContext(AuthContext)
}

const AuthProvider: FC<WithChildren> = ({children}) => {
  const [auth, setAuth] = useState<AuthModel | undefined>(authHelper.getAuth())
  const [currentUser, setCurrentUser] = useState<UserModel | undefined>()
  const saveAuth = (auth: AuthModel | undefined) => {
    setAuth(auth)
    if (auth) {
      authHelper.setAuth(auth)
    } else {
      authHelper.removeAuth()
    }
  }

  const logout = () => {
    saveAuth(undefined)
    setCurrentUser(undefined)
   
  }

  return (
    <AuthContext.Provider value={{auth, saveAuth, currentUser, setCurrentUser, logout}}>
      {children}
    </AuthContext.Provider>
  )
}

const AuthInit: FC<WithChildren> = ({children}) => {
  const {auth, currentUser, logout, setCurrentUser, saveAuth} = useAuth()
  const didRequest = useRef(false)
  const [showSplashScreen, setShowSplashScreen] = useState(true)
  // We should request user by authToken (IN OUR EXAMPLE IT'S API_TOKEN) before rendering the application
  useEffect(() => {
    
    const sign = require('jwt-encode')

    const secretKey = 'At98rMtq6PndWiNoMQhKcDvbPigQiBuz'
    const data = {
      APPID: 12,
      UUID: uuidv4(),
    }

    const jwtToken = sign(data, secretKey)
    createNewHeaders(jwtToken)

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const tokenParams = urlParams.get('access_token');
    const requestUser = async (apiToken: string) => {
      try {
        if (!didRequest.current) {
          if(tokenParams == null) {
            const formData = new FormData()
            formData.append('TOKENSSO', apiToken)
            const json = await executePost(SSO, formData)
            if (json.code === 200) {
              localStorage.setItem('uid', json.data.user.id)
              localStorage.setItem('apptoken', json.data.token)
              setCurrentUser(json.data)
              localStorage.setItem('currentUser', JSON.stringify(json.data))
            } else {
              MySwal.fire({
                title: 'Pesan!',
                text: json.msg,
                icon: 'error',
                customClass: {
                  confirmButton: 'btn btn-success'
                }
              })
            }
          } else {
            const formData = new FormData()
            formData.append('TOKENSSO', tokenParams)
            const json = await executePost(SSO, formData)
            if (json.code === 200) {
              localStorage.setItem('uid', json.data.user.id)
              localStorage.setItem('apptoken', json.data.token)
              saveAuth(json.data)
              setCurrentUser(json.data)
              localStorage.setItem('currentUser', JSON.stringify(json.data))
            } else {
              MySwal.fire({
                title: 'Pesan!',
                text: json.msg,
                icon: 'error',
                customClass: {
                  confirmButton: 'btn btn-success'
                }
              })
            }
          }
        } else {
          if(tokenParams == null) {
            const formData = new FormData()
            formData.append('TOKENSSO', apiToken)
            const json = await executePost(SSO, formData)
            if (json.code === 200) {
              localStorage.setItem('uid', json.data.user.id)
              localStorage.setItem('apptoken', json.data.token)
              setCurrentUser(json.data)
              localStorage.setItem('currentUser', JSON.stringify(json.data))
            } else {
              MySwal.fire({
                title: 'Pesan!',
                text: json.msg,
                icon: 'error',
                customClass: {
                  confirmButton: 'btn btn-success'
                }
              })
            }
          } else {
            const formData = new FormData()
            formData.append('TOKENSSO', tokenParams)
            const json = await executePost(SSO, formData)
            if (json.code === 200) {
              localStorage.setItem('uid', json.data.user.id)
              localStorage.setItem('apptoken', json.data.token)
              setCurrentUser(json.data)
              localStorage.setItem('currentUser', JSON.stringify(json.data))
            } else {
              MySwal.fire({
                title: 'Pesan!',
                text: json.msg,
                icon: 'error',
                customClass: {
                  confirmButton: 'btn btn-success'
                }
              })
            }
          }
        }
      } catch (error) {
        if (!didRequest.current) {
          logout()
        }
      } finally {
        setShowSplashScreen(false)
      }

      return () => (didRequest.current = true)
    }

    if (auth && auth.token) {
      requestUser(auth.token)
    } else {
      if(tokenParams != null) {
        requestUser(tokenParams)
      } else {
        logout()
        setShowSplashScreen(false)
      }
      
    }
    // eslint-disable-next-line
  }, [])

  return showSplashScreen ? <LayoutSplashScreen /> : <>{children}</>
}

export {AuthProvider, AuthInit, useAuth}
